"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./BlackFridayStats.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-720":{"id":"e-720","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-721"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"074bcdc5-7fe5-4c03-fe2f-7edadf691fd8","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"074bcdc5-7fe5-4c03-fe2f-7edadf691fd8","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1732310899167},"e-722":{"id":"e-722","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-723"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"074bcdc5-7fe5-4c03-fe2f-7edadf691fda","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"074bcdc5-7fe5-4c03-fe2f-7edadf691fda","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1732310899167}},"actionLists":{"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function BlackFridayStats({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "blackfriday_section-stats")}
      tag="section"
      grid={{
        type: "section",
      }}
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "container-large")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "padding-section-medium")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "padding-global")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "blackfriday_container-stats",
                "max-width-xxlarge",
                "align-center"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "blackfriday_stats-column",
                  "left"
                )}
                tag="div"
              >
                <_Builtin.Paragraph
                  className={_utils.cx(
                    _styles,
                    "subheading-style",
                    "text-color-brand"
                  )}
                  data-w-id="074bcdc5-7fe5-4c03-fe2f-7edadf691fd8"
                >
                  {"our reach"}
                </_Builtin.Paragraph>
                <_Builtin.Heading
                  className={_utils.cx(_styles, "blackfriday_stats-heading")}
                  data-w-id="074bcdc5-7fe5-4c03-fe2f-7edadf691fda"
                  tag="h3"
                >
                  {"Get in front of qualified tenants"}
                </_Builtin.Heading>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "blackfriday_stats-column",
                  "grid",
                  "max-width-large"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "blackfriday_stats-wrapper")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "blackfriday_stats-container-icon"
                    )}
                    tag="div"
                  >
                    <_Builtin.Image
                      className={_utils.cx(_styles, "blackfriday_stats-icon")}
                      width="auto"
                      height="auto"
                      loading="lazy"
                      alt=""
                      src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/664d1b9b5ed03ebbf7f7cb68_icon-visits.svg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "blackfriday_stats-copy-wrap",
                      "text-align-center"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "blackfriday_stats-stat-wrap"
                      )}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "blackfriday_stats-stat")}
                        tag="div"
                        fb-count="true"
                        fb-count-target="287"
                        fb-count-delay="300"
                        fb-count-time="500"
                      >
                        {"287"}
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(_styles, "blackfriday_stats-stat")}
                        tag="div"
                      >
                        {"k+"}
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "blackfriday_stats-description",
                        "text-weight-bold"
                      )}
                      tag="div"
                    >
                      {"monthly visits"}
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "blackfriday_stats-wrapper")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "blackfriday_stats-container-icon"
                    )}
                    tag="div"
                  >
                    <_Builtin.Image
                      className={_utils.cx(_styles, "blackfriday_stats-icon")}
                      width="auto"
                      height="auto"
                      loading="lazy"
                      alt=""
                      src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/64e7bf71c7788d0652fba901_leads%203.svg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "blackfriday_stats-copy-wrap",
                      "text-align-center"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "blackfriday_stats-stat-wrap"
                      )}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "blackfriday_stats-stat")}
                        tag="div"
                        fb-count="true"
                        fb-count-target="180"
                        fb-count-delay="300"
                        fb-count-time="500"
                      >
                        {"180"}
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(_styles, "blackfriday_stats-stat")}
                        tag="div"
                      >
                        {"k+"}
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "blackfriday_stats-description",
                        "text-weight-bold"
                      )}
                      tag="div"
                    >
                      {"qualified tenants"}
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "blackfriday_stats-wrapper")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "blackfriday_stats-container-icon"
                    )}
                    tag="div"
                  >
                    <_Builtin.Image
                      className={_utils.cx(_styles, "blackfriday_stats-icon")}
                      width="auto"
                      height="auto"
                      loading="lazy"
                      alt=""
                      src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/64e7bf5aacd30224a6438216_views%203.svg"
                    />
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "blackfriday_stats-copy-wrap",
                      "text-align-center"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "blackfriday_stats-stat-wrap"
                      )}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "blackfriday_stats-stat")}
                        tag="div"
                        fb-count="true"
                        fb-count-target="2,600"
                        fb-count-delay="300"
                        fb-count-time="500"
                      >
                        {"2,600"}
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(_styles, "blackfriday_stats-stat")}
                        tag="div"
                      >
                        {"+"}
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "blackfriday_stats-description",
                        "text-weight-bold"
                      )}
                      tag="div"
                    >
                      {"new renter sign ups per month"}
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
